import React from 'react';

const useForceUpdate = () => {
  const [, dispatch] = React.useReducer(() => ({}), {});
  return dispatch;
};

export default useForceUpdate;
